import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {createBusinessService, getBusinessServices,} from "app/redux/businessServicesSlice";
import {Product, useCatalog} from "../../useCatalog";
import {createProduct} from "../../../redux/productSlice";

interface AddItemPayload {
    title: string;
    description: string;
    service_category_id: number;
    price: number;
    type: "service" | "product";
    duration?: number;
    stock?: number;
    notes?: string;
}

export const useAddItem = ({
                               onSuccess,
                           }: {
    onSuccess?: () => void;
}) => {
    const dispatch = useDispatch();
    // const {setProducts}=useCatalog()

    const addItem = async (item: AddItemPayload) => {
        try {
            if (item.type === "service") {
                const service = await dispatch(
                    createBusinessService({
                        title: item.title,
                        description: item.description,
                        duration: item.duration || 30,
                        priceCents: item.price * 100,
                        service_category_id: +item.service_category_id,
                        notes: item.notes,
                    }) as any
                ).unwrap();

                // await dispatch(getEmployees() as any).unwrap();
                await dispatch(getBusinessServices() as any).unwrap();
                toast.success(`Service "${item.title}" created successfully`);
                onSuccess?.();
                return service;
            } else {

                const product = await dispatch(
                  createProduct({
                    title: item.title,
                    description: item.description,
                    priceCents: item.price * 100,
                    stock: item.stock || 0,
                    productCategoryId: +item.service_category_id,
                  }) as any
                ).unwrap();
                // setProducts((prev: Product[]) => [
                //     ...prev,
                //     {
                //         id: Date.now(),
                //         type: "product",
                //         name: item.title,
                //         description: item.description,
                //         category:'products',
                //         price: item.price,
                //         stock: item.stock ?? 0,
                //     },
                // ]);

                toast.success(`Product "${item.title}" created successfully`);
                onSuccess?.();
                // return product;
            }
        } catch (err:any) {
            console.error(err);
            toast.error(err?.data?.error ?? "Failed to create item. Please try again.");
        }
    };

    return {addItem};
};
